export const B = {
  forest: '#1a6b4a',
  mint:   '#4ecb8d',
  amber:  '#f5a623',
  night:  '#0f1923',
  sand:   '#f7f4ef',
  // Page backdrop: sand + repeating travel doodles (public/patterns/travel-doodle.svg).
  sandPattern: "#f7f4ef url('/patterns/travel-doodle.svg') 0 0 / 450px repeat",
  // Lighter (~7%) variant for text-heavy pages like Home: a sand wash over the same tile.
  sandPatternSoft: "linear-gradient(rgba(247,244,239,0.45), rgba(247,244,239,0.45)), url('/patterns/travel-doodle.svg') 0 0 / 450px repeat #f7f4ef",
  muted:  '#6b7280',
  sky:    '#0ea5e9',
  success: '#22c55e',
  warning: '#f59e0b',
  error:   '#ef4444',
  info:    '#3b82f6',
};

export const VIBES = [
  { id: 'all',         label: 'All',         emoji: '🌍' },
  { id: 'relaxing',    label: 'Relaxing',    emoji: '🌴' },
  { id: 'adventurous', label: 'Adventurous', emoji: '🧗' },
  { id: 'romantic',    label: 'Romantic',    emoji: '💕' },
  { id: 'cultural',    label: 'Cultural',    emoji: '🏛️' },
  { id: 'foodie',      label: 'Foodie',      emoji: '🍜' },
  { id: 'wellness',    label: 'Wellness',    emoji: '🧘' },
  { id: 'nightlife',   label: 'Nightlife',   emoji: '🌃' },
  { id: 'wildlife',    label: 'Wildlife',    emoji: '🦁' },
  { id: 'beach',       label: 'Beach',       emoji: '🏖️' },
  { id: 'mountain',    label: 'Mountain',    emoji: '🏔️' },
  { id: 'urban',       label: 'Urban',       emoji: '🏙️' },
  { id: 'luxury',      label: 'Luxury',      emoji: '💎' },
];
